import expediaLocalizations from './expedia';

export default expediaLocalizations;
